exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.card-body[data-v-0ac57c9a] {\n    padding: 5px;\n    max-height: 600px;\n    overflow-y: scroll;\n}\n", ""]);

